import { ListingBuyerSearchResultModel } from '@steelbuy/ts-shared';

import { ListingBuyerSearchData } from './ListingBuyerSearchData';
import { useSearchData } from '../../util/consumer/SearchConsumerHook';

export const useListingBuyerSearchData = () => useSearchData<ListingBuyerSearchResultModel>(ListingBuyerSearchData);
